import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { RoutesList } from '@/router/routesList';
import { useGameWebSocket } from '@/store/gameWebSocket';
import { useSetPageData } from '@/tools/hooks';
import { GridSchedule } from './components/GridSchedule';
export var PlaceSlotsPage = function () {
    var placeId = useParams().placeId;
    var _a = useState(0), refreshToken = _a[0], setRefreshToken = _a[1];
    useSetPageData({
        title: 'Расписания',
        backLink: RoutesList.Place.getPlaceDetails(placeId),
    });
    var _b = useGameWebSocket({
        url: process.env.REACT_APP_WS_URL || 'http://localhost:3000',
        autoConnect: true,
    }), connected = _b.connected, subscribeToPlace = _b.subscribeToPlace, unsubscribeFromPlace = _b.unsubscribeFromPlace, onEvent = _b.onEvent, offEvent = _b.offEvent;
    useEffect(function () {
        if (connected && placeId) {
            subscribeToPlace(placeId);
        }
        return function () {
            if (placeId) {
                unsubscribeFromPlace(placeId);
            }
        };
    }, [connected, placeId, subscribeToPlace, unsubscribeFromPlace]);
    useEffect(function () {
        var handleGameEvent = function () {
            setRefreshToken(function (value) { return value + 1; });
        };
        onEvent('game:reserved', handleGameEvent);
        onEvent('game:released', handleGameEvent);
        onEvent('game:updated', handleGameEvent);
        return function () {
            offEvent('game:reserved', handleGameEvent);
            offEvent('game:released', handleGameEvent);
            offEvent('game:updated', handleGameEvent);
        };
    }, [offEvent, onEvent]);
    return _jsx(GridSchedule, { placeId: placeId, refreshToken: refreshToken });
};
